import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Lookup,
    Summary,
    TotalItem,
} from "devextreme-react/data-grid";
import { HeaderLayout, SearchLayout } from './Layout';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import { LoadPanel, TextBox } from 'devextreme-react';
import axios from 'axios';
import data from '../../../assets/apiRoutes.json'
import notify from 'devextreme/ui/notify';
import { MESSAGES } from '../../../common/Messages';
import { CONCURRENCY_HANDLED, getApiErrorMessage } from '../../../common/concurrency';
import { alert, confirm } from 'devextreme/ui/dialog';
import { OM } from '../../../const/constants';
import { TransactionTypes, TripTransactionGridOptions } from '../../../enum/Enum';
import GridOptionsButton from '../../../common/GridOptionsButton';
const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
// Delphi uOMD0031 pmOptionsNavTop.
const gridOptionItems = [TripTransactionGridOptions.DeleteAll, TripTransactionGridOptions.RegenerateStops];
const From = (props) => {
    const history = useHistory();
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var accessToken = props.oidc.user.access_token;
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const rowId = useRef(null);
    const dataGrid = useRef(null);
    const [resultData, setResultData] = useState(null);
    const gridKey = "5BAA61C5-5895-465A-90EC-AA9A621113E1";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const formRefs = useRef({});
    const initialFormFields = {
        FMTRIPNUMBER: "",
        R_TRUCK: null,
        TRUCKARRIVALDATETIME: null,
        R_DRIVER: null,
        R_TRAILER: null,
        R_FMSHIPPER: null,
        R_SHIPVIA: null,
        ROWID: "",
        TRANSACTIONNUMBER: "",
        SHIPPINGDATE: null,
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            rowId.current = selectedRowsData[0].ROWID;
        }
        else {
            rowId.current = '';
        }
        setIsEditButtonDisabled(!isEditButtonDisabled);
    };
    useEffect(() => {
        if (props.id) {
            LoadData();
        }
    }, [props.id]);
    const LoadData = async () => {
        const result = await loadDatasource(`?TripNumber=${props.id}`);
        if (result.data && result.data.length > 0) {
            setResultData(result.data);
            let data = result.data[0];
            setformFields(prevState => ({
                ...prevState,
                FMTRIPNUMBER: data.FMTRIPNUMBER,
                R_TRUCK: data.R_TRUCK,
                TRUCKARRIVALDATETIME: data.TRUCKARRIVALDATETIME,
                TRUCKDEPARTDATETIME: data.TRUCKDEPARTDATETIME,
                R_DRIVER: data.R_DRIVER,
                R_TRAILER: data.R_TRAILER,
                SHIPPINGDATE: data.SHIPPINGDATE,
                R_FMSHIPPER: data.R_FMSHIPPER,
                R_SHIPVIA: data.R_SHIPVIA,

            }));
        }
    };
    const loadDatasource = async (params) => {
        setLoadPanelVisible(true);
        const res = await axios.get(`${window._env_.REACT_APP_APIS}/${data.OM.GetTripTransactions}${params}`,
            {
                params: params,
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                }
            }).finally(() => {
                setLoadPanelVisible(false);
            });
        return res;
    }
    const handleFieldChange = (() => {
        let lastCall = { name: null, value: null };
        return (name, value, e) => {
            if (name === "ROWID" && !(lastCall.name === name && lastCall.value === value)) {
                addNewRow(value);
            }
            lastCall = { name, value };
        };
    })();
    const handleSelectedItemChange = (name, e) => {

    }
    const handleFormLoad = () => {

    }
    /** The header form's trip assignment on a copy of a grid row. A copy, because the rows in resultData
     *  must keep matching the database until the save succeeds — isSavedOnTrip reads them. */
    const withTripAssignment = (record) => ({
        ...record,
        FMTRIPNUMBER: formFields.FMTRIPNUMBER,
        R_TRUCK: formFields.R_TRUCK,
        TRUCKARRIVALDATETIME: formFields.TRUCKARRIVALDATETIME,
        TRUCKDEPARTDATETIME: formFields.TRUCKDEPARTDATETIME,
        R_DRIVER: formFields.R_DRIVER,
        R_TRAILER: formFields.R_TRAILER,
        SHIPPINGDATE: formFields.SHIPPINGDATE,
        R_FMSHIPPER: formFields.R_FMSHIPPER,
        R_SHIPVIA: formFields.R_SHIPVIA,
    });
    const handleSubmit = async () => {
        // A trip exists only as FMTRIPNUMBER on its transactions, so with none in the grid there is nothing to save.
        if (!resultData || resultData.length === 0) {
            notify({ message: MESSAGES.TRIP_HAS_NO_TRANSACTIONS, width: 450 }, 'warning', 3000);
            return;
        }
        const tripNumber = formFields.FMTRIPNUMBER;
        const dataToUpdate = resultData.map(withTripAssignment);
        const saved = await saveTrip(data.OM.BatchUpdateTransactionHeader, dataToUpdate, MESSAGES.UPDATE_SUCCESS);
        // Reloaded after a failed save too: the batch stops at the first header that fails, but the headers
        // before it are already saved.
        if (tripNumber) {
            await reloadTrip(tripNumber);
        }
        else if (saved) {
            setResultData(dataToUpdate);
        }
    };
    /** Delphi btnUpdateClick reopens the trip after Update, so the grid shows what was saved, with each row's
     *  current version. A row the database did not take stays in the grid after the saved ones, still picked. */
    const reloadTrip = async (tripNumber) => {
        try {
            const result = await loadDatasource(`?TripNumber=${tripNumber}`);
            const savedRows = result.data ?? [];
            const savedRowIds = new Set(savedRows.map(row => row.ROWID));
            setResultData(prevData => [...savedRows, ...(prevData ?? []).filter(row => !savedRowIds.has(row.ROWID))]);
        } catch (error) {
            alert(getApiErrorMessage(error, MESSAGES.ERROR), MESSAGES.ERROR);
        }
    };
    /** PUTs a trip change. Resolves with the response when it was saved and with null when it was not: every
     *  trip endpoint answers an error status when nothing was saved, so every failure arrives in the catch. */
    const saveTrip = (route, payload, message) => {
        setLoadPanelVisible(true);
        return axios.put(`${window._env_.REACT_APP_APIS}/${route}`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                }
            })
            .then((response) => {
                notify(message, 'success', 3000);
                return response;
            }).catch((error) => {
                if (!error?.[CONCURRENCY_HANDLED]) {
                    alert(getApiErrorMessage(error, MESSAGES.ERROR), MESSAGES.ERROR);
                }
                return null;
            }).finally(() => {
                setLoadPanelVisible(false);
            });
    }
    const getNextTransNumber = async () => {
        try {
            const response = await axios.get(
                `${window._env_.REACT_APP_APIS}/${data.AB.GetTransactionNo}`,
                {
                    params: {
                        Module: OM,
                        TransactionType: TransactionTypes.FMTripNumber,
                    },
                    headers: {
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error(MESSAGES.FETCH_ERROR, error);
            throw error;
        }
    };
    const handleReset = () => {
        LoadData();
    }
    const handleAddNew = async () => {
        let fields = { ...initialFormFields };
        fields.FMTRIPNUMBER = await getNextTransNumber();
        setformFields(fields);
        setResultData([]);
    }

    const addNewRow = async (rowid) => {
        if (!rowid) return;
        const rowToAdd = await loadDatasource(`?Rowid=${rowid}`);
        if (rowToAdd.data && rowToAdd.data.length > 0) {
            const newRow = rowToAdd.data[0];

            setResultData(prevData => {
                if (!prevData || prevData.length === 0) {
                    // If no existing data, return array with the new row
                    return [newRow];
                }

                // Check for duplicate before adding (using latest state)
                const isDuplicate = prevData.some(row => row.ROWID === newRow.ROWID);
                if (isDuplicate) {
                    notify({ message: MESSAGES.TRANSACTION_ALREADY_IN_LIST, width: 450 }, 'warning', 3000);
                    return prevData;
                }

                // Append single row at the end of existing data
                return [...prevData, newRow];
            });
        }
    }
    /** FMTRIPNUMBER is char(10), so a trip read back from the database is padded with spaces ("F26-00031 ")
     *  while the number Add gives it is not. Compared as SQL Server compares them, ignoring trailing spaces. */
    const isSameTrip = (tripNumber, otherTripNumber) => (tripNumber ?? '').trimEnd() === (otherTripNumber ?? '').trimEnd();
    /** A grid row already saved on this trip. Rows picked but not yet saved were never on it (their
     *  FMTRIPNUMBER is another trip's, or blank), so Delete and Delete All only drop them from the grid. */
    const isSavedOnTrip = (row) => row.FMTRIPNUMBER?.trim() && isSameTrip(row.FMTRIPNUMBER, formFields.FMTRIPNUMBER);
    /** What the grid operations send for a row: its key, the trip it is on and the version the grid loaded.
     *  The server changes a row only while it is still on that trip at that version (anything else is the
     *  "changed by another user" conflict), and writes only the columns the operation owns — never the whole
     *  grid row, which may be older than what is in the database. */
    const tripRowKey = (row) => ({ ROWID: row.ROWID, FMTRIPNUMBER: formFields.FMTRIPNUMBER, ConcurrencyToken: row.ConcurrencyToken });
    /** Takes each saved row's new version from a trip operation's response, so the next operation on the row
     *  does not falsely conflict (Architecture.md rule 16). */
    const withSavedVersions = (rows, savedRows) => {
        const savedById = new Map((savedRows ?? []).map(saved => [saved.ROWID, saved]));
        return rows.map(row => {
            const saved = savedById.get(row.ROWID);
            return saved
                ? { ...row, LASTUPDATEDATETIME: saved.LASTUPDATEDATETIME, LASTUPDATEUSERID: saved.LASTUPDATEUSERID, ConcurrencyToken: saved.ConcurrencyToken }
                : row;
        });
    };
    /** Delphi TfrmOMD0031.ClearTransaction — takes saved rows off this trip. */
    const removeFromTrip = (rows, message) =>
        saveTrip(data.OM.RemoveTransactionsFromTrip, rows.map(tripRowKey), message);
    /** Delphi navDetailsButtonClick (abDelete) — a row saved on this trip is taken off it, then dropped from
     *  the grid. As with the legacy abort, a failed save keeps the row in the grid. */
    const handleDelete = async () => {
        const selectedRowId = rowId.current;
        if (!selectedRowId) return;
        const confirmDelete = await confirm(MESSAGES.DELETE_CONFIRM, "Delete");
        if (!confirmDelete) return;
        const rowToDelete = resultData?.find(row => row.ROWID === selectedRowId);
        if (rowToDelete && isSavedOnTrip(rowToDelete)
            && !(await removeFromTrip([rowToDelete], MESSAGES.DELETE_SUCCESS))) return;

        setResultData(prevData => {
            if (!prevData) return prevData;
            return prevData.filter(row => row.ROWID !== selectedRowId);
        });

        // Clear the selection after deleting the row
        rowId.current = '';
        setIsEditButtonDisabled(true);
    }
    /** Delphi omDeleteAllClick — takes every transaction off the trip and empties the grid. Only rows
     *  already saved on this trip are cleared in the database; the rest are only dropped from the grid. */
    const handleDeleteAll = async () => {
        if (!resultData || resultData.length === 0) return;
        const confirmDeleteAll = await confirm(MESSAGES.REMOVE_ALL_TRIP_TRANSACTIONS_CONFIRM, TripTransactionGridOptions.DeleteAll.name);
        if (!confirmDeleteAll) return;
        const rowsOnTrip = resultData.filter(isSavedOnTrip);
        // The server takes the rows off together or not at all, so a failed save leaves the grid showing
        // exactly what is still on the trip.
        if (rowsOnTrip.length > 0 && !(await removeFromTrip(rowsOnTrip, MESSAGES.TRIP_TRANSACTIONS_REMOVED))) return;
        setResultData([]);
        rowId.current = '';
        setIsEditButtonDisabled(true);
    }
    /** Delphi omRegenerateStopsClick -> TfrmOMM0031.RefreshGridTransactions — renumbers the stops 1..n in
     *  the order the rows were loaded (by stop #, picked rows appended after), not the grid's current sort:
     *  legacy walked its dataset, whose order only its move up/down (SwitchLines) changes. Legacy left the
     *  save to Update; here the new numbers of the rows already on the trip are saved straight away. Picked
     *  rows are not on the trip yet, so theirs are saved when Update OM Transaction puts them on it. */
    const handleRegenerateStops = async () => {
        if (!resultData || resultData.length === 0) return;
        const renumbered = resultData.map((row, index) => ({ ...row, FMPUSTOPNUMBER: index + 1 }));
        const changedOnTrip = renumbered
            .filter((row, index) => isSavedOnTrip(row) && row.FMPUSTOPNUMBER !== resultData[index].FMPUSTOPNUMBER)
            .map(row => ({ ...tripRowKey(row), FMPUSTOPNUMBER: row.FMPUSTOPNUMBER }));
        let rows = renumbered;
        if (changedOnTrip.length > 0) {
            // The server saves them together or not at all, so a failed save leaves the grid showing the
            // stop numbers that are still in the database.
            const response = await saveTrip(data.OM.UpdateTripStopNumbers, changedOnTrip, MESSAGES.TRIP_STOPS_REGENERATED);
            if (!response) return;
            rows = withSavedVersions(renumbered, response.data?.Resultdata);
        }
        else {
            notify(MESSAGES.TRIP_STOPS_REGENERATED, 'success', 3000);
        }
        setResultData(rows);
    }
    const gridOptionHandlers = {
        [TripTransactionGridOptions.DeleteAll.id]: handleDeleteAll,
        [TripTransactionGridOptions.RegenerateStops.id]: handleRegenerateStops,
    };
    const onGridOptionItemClick = (e) => gridOptionHandlers[e.itemData?.id]?.();
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    return (<div>
        <div className="row">
            <div className="col-md-12 main-page">
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    onHiding={hideLoadPanel}
                    visible={loadPanelVisible}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    hideOnOutsideClick={false}
                />
                <Toolbar >
                    <Item location="before">
                        <div className="title">
                            <h6
                                style={{
                                    color: window._env_.Color2
                                }}
                            >
                                Update Route/Trips on Orders
                            </h6>
                        </div>
                    </Item>
                    <Item location="after">
                        <Button className="accordianButton" onClick={handleAddNew} text="Add" type="default" />
                    </Item>
                    <Item location="after">
                        <Button className="accordianButton" onClick={handleSubmit} text="Update OM Transaction" type="default" />
                    </Item>
                    <Item location="after">
                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                    </Item>
                    <Item location="after">
                        <Button className="accordianButton" onClick={() => history.push('/om/transactions/delivery-management/list')} text="Back" />
                    </Item>
                </Toolbar>
                <div style={{ height: 165, marginBottom: 20, backgroundColor: "#fff" }} >
                    <FormField
                        currrentUser={currentUser}
                        layoutId='847B23EC-DA0B-4643-B8DD-EF0C2009F0CD'
                        layoutName='OMTripsForm'
                        defaultFormSchema={HeaderLayout}
                        formFields={formFields}
                        setformFields={setformFields}
                        handleFieldValueChange={handleFieldChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={formRefs}
                        onFormLoad={handleFormLoad}
                        handleSelectedItemChange={handleSelectedItemChange}
                    />
                </div>
                <DataGrid
                    onExporting={(e) => {
                        if (window.handleDevExtremeDataGridExport) {
                            window.handleDevExtremeDataGridExport(e);
                        }
                    }}
                    ref={dataGrid}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    dataSource={resultData}
                    keyExpr="ROWID"
                    showBorders={true}
                    hoverStateEnabled={true}
                    className="GridHeightAccordianClose-tabs-with-fields"
                    onSelectionChanged={(e) => onSelectionChanged(e)}
                    remoteOperations={false}
                    searchEnabled={true}
                    columnAutoWidth={true}
                >
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <Export enabled={true} allowExportSelectedData={true} />
                    <Selection mode="single" />
                    <Sorting visible={true} mode="multiple" />
                    <FilterPanel visible={true} />
                    <GroupPanel visible={true} />
                    <Grouping autoExpandAll={false} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={loadState}
                        storageKey={gridKey}
                        customSave={saveState}
                    />
                    <FilterRow visible={true} />
                    <Paging enabled={false} />
                    <Column dataField="FMPUSTOPNUMBER" caption="Stop #" dataType="number" />
                    <Column dataField="TRANSACTIONNUMBER" caption="Transaction #" dataType="string" />
                    <Column dataField="SHIPTONAME" caption="Consignee Name" dataType="string" />
                    <Column dataField="SHIPTOID" caption="Consignee" dataType="string" />
                    <Column dataField="CONSIGNEEADDRESS1" caption="Consignee Address 1" dataType="string" />
                    <Column dataField="CONSIGNEEADDRESS2" caption="Consignee Address 2" dataType="string" />
                    <Column dataField="CONSIGNEECITY" caption="Consignee City" dataType="string" />
                    <Column dataField="CONSIGNEESTATE" caption="Consignee State" dataType="string" />
                    <Column dataField="CONSIGNEEZIP" caption="Consignee Zip" dataType="string" />
                    <Column dataField="CONSIGNEECOUNTRY" caption="Consignee Country" dataType="string" />
                    <Column dataField="CONSIGNEETELEPHONE1" caption="Consignee Telephone 1" dataType="string" />
                    <Column dataField="CUSTOMERIDENTITYID" caption="Customer Code" dataType="string" />
                    <Column dataField="CUSTOMERNAME" caption="Customer Name" dataType="string" />
                    <Column dataField="SALESPERSON1" caption="Sales Person" dataType="string" />
                    <Column dataField="PURCHASEORDERNUMBER" caption="PO #" dataType="string" />

                    <Column dataField="TotalAmount" caption="Amount" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column dataField="NetWeight" caption="Weight" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column dataField="QuantityShippedSum" caption="Volume" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column dataField="OrderedQuantity" caption="Ordered Quantity" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column dataField="ShippedQuantity" caption="Shipped Quantity" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />

                    <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} dataField="USERDEFINEDQUANTITY_1" caption="User Defined Quantity 1" />
                    <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} dataField="USERDEFINEDQUANTITY_2" caption="User Defined Quantity 2" />
                    <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} dataField="USERDEFINEDQUANTITY_3" caption="User Defined Quantity 3" />
                    <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} dataField="USERDEFINEDQUANTITY_4" caption="User Defined Quantity 4" />
                    <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} dataField="USERDEFINEDQUANTITY_5" caption="User Defined Quantity 5" />
                    <Summary>
                        <TotalItem
                            column="TotalAmount"
                            summaryType="sum"
                            valueFormat={{ type: 'fixedPoint', precision: 2, useGrouping: true }}
                            displayFormat="Amount: {0}"
                        />
                        <TotalItem
                            column="NetWeight"
                            summaryType="sum"
                            valueFormat={{ type: 'fixedPoint', precision: 2, useGrouping: true }}
                            displayFormat="Weight: {0}"
                        />
                        <TotalItem
                            column="QuantityShippedSum"
                            summaryType="sum"
                            valueFormat={{ type: 'fixedPoint', precision: 2, useGrouping: true }}
                            displayFormat="Volume: {0}"
                        />
                    </Summary>
                    <GridToolbar>
                        <GridToolbarItem location="before">
                        </GridToolbarItem>
                        <GridToolbarItem location="after">
                            <Button
                                onClick={handleDelete}
                                icon="trash"
                                disabled={!rowId.current}
                            />
                        </GridToolbarItem>
                        <GridToolbarItem location="after">
                            <GridOptionsButton
                                items={gridOptionItems}
                                onItemClick={onGridOptionItemClick}
                                disabled={!resultData?.length}
                            />
                        </GridToolbarItem>
                        <GridToolbarItem location="after">
                            <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                        </GridToolbarItem>
                        <GridToolbarItem name="exportButton" />
                        <GridToolbarItem name="columnChooserButton" />
                    </GridToolbar>
                </DataGrid>
            </div>
        </div>
    </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}
export default connect(mapStateToProps)(From);